import { render, staticRenderFns } from "./EmbedInstructionsWrapper.vue?vue&type=template&id=b8963a2e&"
import script from "./EmbedInstructionsWrapper.vue?vue&type=script&lang=js&"
export * from "./EmbedInstructionsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports